const locationService = {
  // eslint-disable-next-line no-return-assign
  redirect: (url) => (window.location = url),
};
export default locationService;
